module.exports = __webpack_public_path__ + "static/media/ec-photo.52ad82e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/upsellEc/ec-photo.png
// module id = 1226
// module chunks = 0